import client from "./axiosConfig";

export const getStockAdjustmentNote = (params) => {
  const config = {
    url: `/inventory/stock-adjustment-note/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const createStockAdjustmentNote = (data) => {
  const config = {
    url: `/inventory/stock-adjustment-note/`,
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const getStockAdjustmentNoteById = (id) => {
  const config = {
    url: `/inventory/stock-adjustment-note/${id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const updateStockAdjustmentNote = (id, data) => {
  const config = {
    url: `/inventory/stock-adjustment-note/${id}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const deleteStockAdjustmentNote = (id) => {
  const config = {
    url: `/inventory/stock-adjustment-note/${id}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
};

export const getSANMaterials = (san_id, params) => {
  const config = {
    url: `/inventory/stock-adjustment-note/${san_id}/materials/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const addSANMaterials = (san_id, data) => {
  const config = {
    url: `/inventory/stock-adjustment-note/${san_id}/materials/`,
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};
